// 介錯の外套のはためき (2026-11-02・答えるページ exec-pass4-1102 の cloak =「描く (まず型を1つ)」)。
//   踏み込みの着地の絵 step_land (肩の布が前へ振れて胸に巻き付く) から待機の絵 idle (布が背中側へ垂れる) へ、
//   布が1コマで飛んでいた。その間に「布が後ろへ戻って翻る」1枚 step_settle を、着地のあとの立ち直り (settle) の頭に挟む。
//   時間・当たり・移動は変えない (絵を選ぶだけ)。刃の前への一歩だけ。砲・後ろ跳び・瞬歩は型が通ってから広げる。
//   1枚の版は ?execCloak=settle で比べられる。記録 = docs/research/2026-11-02-exec-cloak-settle.md
export const EXEC_CLOAK_SETTLE_MS = 140
/** step_settle の横の置き場所 (絵の x px)。足の外側の中点 478.5 から、待機の絵の「足が箱の中心より 15.5px 右」を引いた値。 */
export const EXEC_CLOAK_SETTLE_ANCHOR_X = 463

// 11-03 作者「直してから入れる」「もたついてるというか流れるような自然なはためきにはなってない」。
//   1枚を 140ms 止めて出すと、布が止まって見え、前後で2回飛ぶ。つなぎの3枚を足し、布が止まらず流れる版 ?execCloak=flow。
//   着地の終わり 50ms に舞い上がり (lift)、立ち直りの 140ms を 翻り (step_settle) → 落ち (fall) → 垂れかけ (drop) で 3 等分する。
//   長さは 140ms のまま (作者の答え)。着地の時間・当たりは変えない (着地の絵の終わりを差し替えるだけ)。
/** 着地の何 ms 目から舞い上がりの絵にするか (着地は 200ms)。 */
export const EXEC_CLOAK_FLOW_LIFT_FROM_MS = 150
export const EXEC_CLOAK_FLOW_KEYS = ['step_settle', 'step_cloak_fall', 'step_cloak_drop'] as const
/** つなぎの3枚の横の置き場所 (絵の x px)。足の外側の中点 (495 / 479 / 479) − 15.5 (step_settle と同じ決め方)。 */
export const EXEC_CLOAK_FLOW_ANCHOR_X: Partial<Record<string, number>> = {
  step_cloak_lift: 479.5,
  step_cloak_fall: 463.5,
  step_cloak_drop: 463.5,
}

// 11-03 作者「入れる」「めっちゃいいな」「動いて見える」→ 配布版の既定を flow にした。前の版は ?execCloak=off (挟まない)・?execCloak=settle (1枚)。
// 11-03 作者 wide＝「砲の踏み込みにも」→ 砲の4枚 (cannon/ の同じキー・Codex 描き) も流す版 ?execCloak=cannon。
//   刃の割り振りそのまま、砲の時も出すだけ。後ろ跳びには出さない。作者の答えまで配布版は刃だけ。
//   記録 = docs/research/2026-11-03-exec-cloak-cannon.md
/** 砲の4枚の横の置き場所 (絵の x px)。11-03 作者「絵の変わり目でガクガク」→ 足でなく頭・ベルト・両足の並びが
 *  着地→待機へ一方向に寄るよう置き直した (画面の頭の横 px: 着地 −27 → −15 → −8 → −8 → −2 → 待機 0。直す前は −27 → −17 → −19 → −27 → −3 → 0)。
 *  落ちる・なびくの2枚は上半身が前へ倒れすぎていたので、足の裏を止めて上を後ろへ斜めにずらした (幅 1120 / 1056)。
 *  11-03 作者「待機に戻るときにかくつきというか飛びがある」→ 4枚のコートが待機より約3割明るく暖色で、垂れかけ→待機で1コマに暗くなっていた。
 *  4枚の色を待機の絵に合わせた (色の分布を待機へ写す・形は同じ。前の絵は LUNAIRE-notes/archived/exec-cloak-cannon-pre-tone-1103)。 */
// 11-04 作者「踏み込みの外套はこのえがはさまってるのがすごい気になる。ちらついて見える」→ 砲の舞い上がり (step_cloak_lift) だけ布が頭の上へ羽根の束のように
//   立ち、前後の3枚 (布が横へ流れる) と形が別物で、50ms だけ光って見えた (明るい布の上端 y 4 / 次の絵 38・重なり 0.14)。色は揃っていたので形の問題。
//   描き直すより外す方が確実なので、砲では舞い上がりを出さず着地の絵を 200ms 通す (4枚)。絵は残す (cannon/step_cloak_lift)。刃は変えない。
export const EXEC_CLOAK_CANNON_ANCHOR_X: Partial<Record<string, number>> = {
  step_cloak_lift: 455,
  step_settle: 435,
  step_cloak_fall: 426,
  step_cloak_drop: 473,
}
// 11-04 作者 cannon＝yes → 砲にも流す版を配布版の既定にした。前の版 (刃だけ) は ?execCloak=flow。
let cloakMode: 'off' | 'settle' | 'flow' | 'cannon' = 'cannon'
export function setExecCloak(v: string | null): void { cloakMode = v === 'settle' || v === 'off' || v === 'flow' ? v : 'cannon' }
/** 着地のあとに外套のはためきの1枚を挟むか (DEV ?execCloak=settle)。 */
export function execCloakSettleOn(): boolean { return cloakMode === 'settle' }
/** 外套のはためきを5枚で流すか (配布版の既定は刃・砲とも)。 */
export function execCloakFlowOn(): boolean { return cloakMode === 'flow' || cloakMode === 'cannon' }
/** 砲の踏み込みにも流す4枚を出すか (配布版の既定・刃だけの前の版は ?execCloak=flow)。 */
export function execCloakCannonOn(): boolean { return cloakMode === 'cannon' }

// 11-03 作者「待機に戻るときにかくつきというか飛びがあるのでそれを直してほしいだけ」(刃・砲とも)。垂れかけ→待機の飛びの元は2つ:
//   (1) 翻り・落ち・垂れかけの3枚は足に対して上半身が待機より 17px 前にあり、待機で頭が 17px 跳ぶ → 足の裏を止めて上を後ろへ斜めにずらした
//       (傾き 0.036 / 0.05 / 0.064・幅 1072 / 1088 / 1088)。画面の頭の横 px: −16 → −12 → −10 → −7 → −3 → 待機 0 (前は −16 → −12 → −18 → −18 → −17 → 0)。
//   (2) 4枚のコートが待機より約3割明るく暖色で、待機で1コマに暗くなる → 4枚の色を待機の絵に合わせた (形は同じ)。
//   その絵 (<key>_align の4枚) に差し替える。足・置き位置・時間・当たりは変えない。
//   11-04 作者 blade＝yes → 配布版の既定にした。前の絵 (揃える前) は DEV ?execCloakAlign=off。記録 = docs/research/2026-11-03-exec-cloak-cannon.md
let bladeAlign = true
export function setExecCloakAlign(v: string | null): void { bladeAlign = v !== 'off' }
/** 刃の外套の4枚を体で揃えた絵 (<key>_align) にするか (配布版の既定・前の絵は DEV ?execCloakAlign=off)。 */
export function execCloakBladeAlignOn(): boolean { return bladeAlign }
